module.exports = __webpack_public_path__ + "static/media/bags-p-img3.b5c4c457.jpg";